<template>
  <div>
    <top-bar heading="Message"></top-bar>
    <div class="container-fluid mt-3">
      <div class="row">
        <div class="col-12 col-lg-9">
          <div class="col-12 mb-3">
            <div class="card" v-for="message in thread.messages" :key="message.id">
              <div class="card-header">
                #{{ message.id }} - {{ message.created_at | moment('calendar') }}
              </div>
              <div class="card-body">
                <div class="row m-0 p-0">
                  <div class="col-4 col-lg-2 text-center p-4 border-right bg-gray-100">
                    <div>
                      <img :src="message.user.photo_url" class="img-fluid rounded-circle" :alt="message.user.name_full">
                    </div>
                    <div class="text-bold">
                      {{ message.user.name_full }}
                    </div>
                    <div class="message-role">
                      {{ message.user.role_name }}
                    </div>
                  </div>
                  <div class="col p-4">
                    <div v-html="message.body">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <b-card header="Reply">
              <b-card-body class="p-3">
                <vue-editor v-model="reply"></vue-editor>
                <loading-button :loading="loading" :disabled="!reply" block @submit="sendReply">Reply</loading-button>
              </b-card-body>
            </b-card>
          </div>
        </div>
        <div class="col-3 d-none d-lg-block">
          <b-card header="Participants">
            <div v-for="user in thread.participants" class="row m-0 p-2 border-bottom" :key="'participant-' + user.id">
              <div class="col-3">
                <img :src="user.photo_url" class="img-fluid img-avatar"
                     :alt="user.name_full">
              </div>
              <div class="col text-center">
                <div class="text-bold">
                  {{ user.name_full }}
                </div>
                <div>
                  {{ user.role_name }}
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Message',
  data () {
    return {
      thread: {
        messages: [],
        loaded: false,
        replying: false,
        participants: []
      },
      reply: '',
      loading: false
    };
  },
  methods: {
    loadThread () {
      this.thread.loaded = false;
      this.axios.get('/messages/' + this.id).then(rsp => {
        rsp.data.loaded = true;
        this.thread = rsp.data;
      });
    },
    sendReply () {
      if (!this.reply) {
        this.$snotify.error('Please enter a message');
        return;
      }
      this.loading = true;

      this.axios.put('/messages/' + this.id, {body: this.reply}).then(rsp => {
        this.reply = '';
        this.loading = false;
        this.thread = rsp.data;
      });
    }
  },
  mounted () {
    this.loadThread();
  },
  metaInfo: {
    title: 'Message'
  },
  props: ['id']
};
</script>
